import { createContext, useContext, type ReactNode } from 'react';

import { useMagicFlowAdminController } from './useMagicFlowAdminController';

export type MagicFlowContextValue = ReturnType<
  typeof useMagicFlowAdminController
>;

const MagicFlowContext = createContext<MagicFlowContextValue | null>(null);

type MagicFlowProviderProps = {
  children: ReactNode;
};

export const MagicFlowProvider = ({ children }: MagicFlowProviderProps) => {
  const controller = useMagicFlowAdminController();
  return (
    <MagicFlowContext.Provider value={controller}>
      {children}
    </MagicFlowContext.Provider>
  );
};

export const useMagicFlowContext = (): MagicFlowContextValue => {
  const value = useContext(MagicFlowContext);
  if (!value) {
    throw new Error(
      'useMagicFlowContext must be used within a MagicFlowProvider'
    );
  }
  return value;
};
